import { render, staticRenderFns } from "./LocalSwitcher.vue?vue&type=template&id=5a25dad0&"
import script from "./LocalSwitcher.vue?vue&type=script&lang=js&"
export * from "./LocalSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports